export default __webpack_public_path__ + "static/media/toggleOnIcon.b69d8cba.svg";